import { Icon } from '@iconify/react'

const FeatureCards = () => {
  const features = [
    {
      icon: null,
      customIcon: true,
      title: '자동 인식',
      subtitle: 'OCR 기술',
    },
    {
      icon: 'solar:lightbulb-bolt-bold',
      customIcon: false,
      title: '독소조항 탐지',
      subtitle: 'AI 분석',
    },
    {
      icon: 'solar:shield-check-bold',
      customIcon: false,
      title: '3줄 요약',
      subtitle: '핵심 파악',
    },
  ]

  return (
    <div className="px-4 py-6">
      <div className="grid grid-cols-3 gap-4">
        {features.map((feature, index) => {
          return (
            <div key={index} className="flex flex-col items-center">
              <div className="w-16 h-16 rounded-lg bg-gray-100 flex items-center justify-center mb-2">
                {feature.customIcon ? (
                  <div className="w-12 h-12 border-2 border-dashed border-gray-400 rounded-full flex items-center justify-center">
                    <span className="text-gray-600 text-xl font-bold">?</span>
                  </div>
                ) : feature.icon ? (
                  <Icon icon={feature.icon} width={32} height={32} className="text-gray-600" />
                ) : null}
              </div>
              <p className="text-sm font-medium text-black text-center mb-1">
                {feature.title}
              </p>
              <p className="text-xs text-gray-500 text-center">
                {feature.subtitle}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default FeatureCards

